/**
 * Shared cell styling for the hand-rolled list tables (tickets, customers, articles).
 *
 * These tables use `table-layout: fixed` with widths declared on the `<th>` elements, a
 * bounded scrollport, and a sticky header. See `hooks/useScrollEdges.ts` for the companion
 * scroll affordance.
 */

/**
 * Header cell. The bottom rule is an inset shadow rather than a border: the header is sticky,
 * and under `border-collapse: collapse` a real border scrolls out of view with the first row.
 */
export const TH_CLASS =
  "px-2 sm:px-3 py-2 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider cursor-pointer hover:bg-muted/80 whitespace-nowrap shadow-[inset_0_-1px_0_hsl(var(--border))]";

/**
 * Body cell. Clips rather than grows — under fixed layout a cell no longer widens to fit its
 * content, so anything longer than its column would otherwise spill across its neighbours.
 */
export const TD_CLASS = "px-2 sm:px-3 py-2 sm:py-3 truncate";
